import { AdsAccountListResponse, AdsHealthResponse, AdsPaybackCampaignDays, AdsPaybackCampaignMarkers, AdsPaybackCampaignOutcomes, AdsPaybackFreshness, AdsPaybackReport, } from '@wit-support/admin-contracts';
import { ModuleRequestError, createModuleApi, moduleRequestErrorFrom, } from '@wit-support/admin-client-core';
import { numberUnnamedCampaigns } from './campaign-name.js';
/** Код ошибки «ответ admin-api не прошёл схему контракта» (тот же, что у admin-api). */
export const CONTRACT_MISMATCH = 'contract_mismatch';
/**
 * Код ошибки «ответ пришёл, но про другой момент» (`report.moment` не тот, что
 * запрошен): данные не показываем — склеили бы чужой прогноз, — а говорим
 * «неожиданный ответ» с «Повторить». Ставит `useMomentReports`, не сеть.
 */
export const MOMENT_MISMATCH = 'moment_mismatch';
/**
 * Клиент раздела «Окупаемость»: admin-api `/api/ads/payback/*` (цифры прогноза
 * только из старого отчёта auto-ads, спека Р1) и справочные `/api/ads/accounts`,
 * `/api/ads/health`. Каждый ответ проверяется схемой контракта.
 *
 * Ошибки — `ModuleRequestError` (`admin-client-core`): `status`, `code`
 * (`ads_not_configured`, `payback_details_not_configured`, `upstream_unavailable`,
 * `contract_mismatch`, `invalid_query`, …), `serverMessage`.
 */
const api = createModuleApi({ errorFormat: 'server-message' });
export function setAdsPaybackApiBaseUrl(url) {
    api.setBaseUrl(url);
}
async function request(schema, path, opts = {}) {
    const r = await api.fetchRaw(path, opts.signal ? { signal: opts.signal } : undefined);
    if (!r.ok)
        throw await moduleRequestErrorFrom(r);
    // Ответ не по контракту — не ZodError с сырым JSON на экране и не повтор,
    // а `contract_mismatch` (своя фраза, `retryOnce` его не повторяет).
    const parsed = schema.safeParse(await r.json());
    if (!parsed.success)
        throw new ModuleRequestError(CONTRACT_MISMATCH, r.status);
    return parsed.data;
}
function qs(params) {
    const p = new URLSearchParams();
    for (const [k, v] of Object.entries(params))
        if (v !== undefined && v !== '')
            p.set(k, v);
    const s = p.toString();
    return s ? `?${s}` : '';
}
const BASE = '/api/ads';
const periodParams = (q) => ({
    from: q.from,
    to: q.to,
    accounts: q.accounts.length ? q.accounts.join(',') : undefined,
});
export const paybackApi = {
    async report(q, opts = {}) {
        const r = await request(AdsPaybackReport, `${BASE}/payback/report${qs({
            ...periodParams(q),
            moment: q.moment,
            model: q.model,
            includeDays: q.includeDays ? '1' : undefined,
        })}`, opts);
        // Номера «без названия» — здесь, а не в одном хуке: тот же reportKey
        // наполняют useReport, useMomentReports и «Признак × кабинеты», и кэш
        // должен быть одинаковым, кто бы его ни заполнил первым.
        numberUnnamedCampaigns(r.campaigns);
        return r;
    },
    campaignMarkers(q, opts = {}) {
        return request(AdsPaybackCampaignMarkers, `${BASE}/payback/campaign-markers${qs({
            ...periodParams(q),
            moment: q.moment,
            model: q.model,
            campaignId: q.campaignId,
        })}`, opts);
    },
    campaignDays(q, opts = {}) {
        return request(AdsPaybackCampaignDays, `${BASE}/payback/campaign-days${qs({
            ...periodParams(q),
            campaignId: q.campaignId,
            model: q.model,
        })}`, opts);
    },
    campaignOutcomes(q, opts = {}) {
        return request(AdsPaybackCampaignOutcomes, `${BASE}/payback/campaign-outcomes${qs({ ...periodParams(q), campaignId: q.campaignId })}`, opts);
    },
    freshness() {
        return request(AdsPaybackFreshness, `${BASE}/payback/freshness`);
    },
    accounts() {
        return request(AdsAccountListResponse, `${BASE}/accounts`);
    },
    health() {
        return request(AdsHealthResponse, `${BASE}/health`);
    },
};
//# sourceMappingURL=api.js.map